import { Link } from "react-router-dom";
import { t } from "../i18n/t";
import { routes } from "../lib/routes";
import { usePageTitle } from "../lib/usePageTitle";

export function NotFoundPage({ message }: { message?: string }) {
  usePageTitle(t("errors.notFoundTitle"));
  return (
    <div className="page narrow">
      <h1>{t("errors.notFoundTitle")}</h1>
      <p>{message ?? t("errors.notFoundBody")}</p>
      <p>
        <Link to={routes.home()}>{t("errors.toHome")}</Link>
      </p>
    </div>
  );
}
